import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './routes/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import GarantiasPage from './pages/GarantiasPage';
import AveriasPage from './pages/AveriasPage';
import ContratosPage from './pages/ContratosPage';
import FacturacionPage from './pages/FacturacionPage';
import EstadisticasPage from './pages/EstadisticasPage';
import DocumentosPage from './pages/DocumentosPage';
import AdminPage from './pages/AdminPage';
import PerfilPage from './pages/PerfilPage';
import ClienteGarantiaPage from './pages/ClienteGarantiaPage';
import ClienteAveriasPage from './pages/ClienteAveriasPage';
import ClienteDocumentosPage from './pages/ClienteDocumentosPage';
import ClienteNotificacionesPage from './pages/ClienteNotificacionesPage';
import ClienteConfiguracionPage from './pages/ClienteConfiguracionPage';

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#363636',
          },
          success: {
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/garantias/*"
          element={
            <ProtectedRoute>
              <GarantiasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/averias/*"
          element={
            <ProtectedRoute>
              <AveriasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contratos/*"
          element={
            <ProtectedRoute>
              <ContratosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facturacion"
          element={
            <ProtectedRoute>
              <FacturacionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/estadisticas"
          element={
            <ProtectedRoute>
              <EstadisticasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documentos"
          element={
            <ProtectedRoute>
              <DocumentosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <PerfilPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cliente/garantia"
          element={
            <ProtectedRoute>
              <ClienteGarantiaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cliente/averias"
          element={
            <ProtectedRoute>
              <ClienteAveriasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cliente/documentos"
          element={
            <ProtectedRoute>
              <ClienteDocumentosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cliente/notificaciones"
          element={
            <ProtectedRoute>
              <ClienteNotificacionesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cliente/configuracion"
          element={
            <ProtectedRoute>
              <ClienteConfiguracionPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
